import * as React from "react";
import { createRoot } from "react-dom/client";
import { Address } from "./address/Address";
import { Blocks } from "./Blocks";
import Routes from "./Routes";
import { getParam } from "./getParam";
import { Block } from "./Block";
import { Navigator, SiteFooter } from "./Navigator";
import { Transaction } from "./transaction/Transaction";
import { Assets } from "./Assets";
import { Asset } from "./Asset";
import { Api } from "./Api";
import { Sidebar } from "./Sidebar";
import {
  BlocksPage,
  BurnsPage,
  DistributionPage,
  MarketsPage,
  MiningPage,
  MovementsPage,
  NetworkPage,
  RichListPage,
  StatsPage,
} from "./ExplorePages";
import "./style.css";

function CurrentView({ route }: { route: string }) {
  switch (route) {
    case Routes.ADDRESS:
      return <Address />;
    case Routes.BLOCK:
      return <Block />;
    case Routes.TRANSACTION:
      return <Transaction />;
    case Routes.ASSETS:
      return <Assets />;
    case Routes.ASSET:
      return <Asset />;
    case Routes.API:
      return <Api />;
    case Routes.BLOCKS:
      return <BlocksPage />;
    case Routes.DISTRIBUTION:
      return <DistributionPage />;
    case Routes.RICHLIST:
      return <RichListPage />;
    case Routes.MOVEMENTS:
      return <MovementsPage />;
    case Routes.BURNS:
      return <BurnsPage />;
    case Routes.MINING:
      return <MiningPage />;
    case Routes.NETWORK:
      return <NetworkPage />;
    case Routes.MARKETS:
      return <MarketsPage />;
    case Routes.STATS:
      return <StatsPage />;
    default:
      return <Blocks />;
  }
}

function App() {
  const [route] = React.useState(() => getParam("route") || Routes.HOME);

  React.useEffect(() => {
    document.title = "Telestai Explorer";
  }, []);

  return (
    <>
      <Navigator />
      <div className="app-body">
        <Sidebar />
        <div className="app-main">
          <CurrentView route={route} />
        </div>
      </div>
      <SiteFooter />
    </>
  );
}

const container = document.getElementById("app");
const root = createRoot(container!);
root.render(<App />);
